<template>
  <div id="UserAddModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p v-if="!userData.portalFlag" class="modal-card-title" style="color: whitesmoke;">ユーザー情報</p>
        <p v-if="userData.portalFlag" class="modal-card-title" style="color: whitesmoke;">ポータル公開設定情報</p>
        <b-button class="withButton" style="margin-left: auto;" @click="$parent.close()">閉じる</b-button>
      </header>
      <section class="modal-card-body">
        <div class="condition-area">
          <table>
            <template v-if="!userData.portalFlag">
            <tr>
              <th style="font-size:13px;">【ユーザー情報】</th>
            </tr>
            <tr v-if="userData.id">
              <th>ユーザーID</th>
              <td class="id-cell">
                {{userData.id}}
                <b-button v-if="editFlag && !userData.portalFlag" class="delete-button" icon-left="account-remove-outline" @click="deleteUser()">削除</b-button></td>
            </tr>
            <tr>
              <th>ユーザー名<span class="require"/></th>
              <td style="display:flex; align-items:center; gap:1px;">
                <input v-model="userData.familyName" class="useInfo" type="text" placeholder="姓" name="ユーザー名(姓)" validate="required" maxlength="50"/>
                <input v-model="userData.firstName" class="useInfo" type="text" placeholder="名" name="ユーザー名(名)" validate="required" maxlength="50"/>
              </td>
            </tr>
            <tr>
              <th>ユーザー名(カナ)<span class="require"/></th>
              <td style="display:flex; align-items:center; gap:1px;">
                <input v-model="userData.familyNameKana" class="useInfo" type="text" placeholder="セイ" name="ユーザー名(姓カナ)" validate="required|kana" maxlength="50"/>
                <input v-model="userData.firstNameKana" class="useInfo" type="text" placeholder="メイ" name="ユーザー名(名カナ)" validate="required|kana" maxlength="50"/>
              </td>
            </tr>
            <tr>
              <th>メールアドレス<span class="require"/></th>
              <td>
                <input v-model="userData.mail" type="text" class="useInfo" name="メールアドレス" validate="required|mail" maxlength="100"/>
              </td>
            </tr>
            <tr>
              <th>メールアドレス(確認)<span class="require"/></th>
              <td>
                <input v-model="userData.mailAddrcomfirm" type="text" class="useInfo" name="メールアドレス(確認)" validate="required" maxlength="100" id="mailAddrcomfirm"/>
              </td>
            </tr>
            <tr>
              <th>パスフレーズ認証</th>
              <td>
                <b-checkbox class="cstmCheckBox" v-model="userData.passPhrase">二要素認証を行う</b-checkbox>
              </td>
            </tr>
            <template v-if="userData.passPhrase">
              <tr>
                <th>パスフレーズ送信先<br/>(携帯番号)</th>
                <td style="display:flex; align-items:center; gap:5px;">
                  <input v-model="userData.passPhrasePhoneNumber" type="text" class="passPhrase" id="passphraseSendNo" name="パスフレーズ送信先(携帯番号)" validate="numeric" maxlength="20"/>
                  <b-button class="withButton" @click="sendTestSMS()">テスト送信</b-button>
                </td>
              </tr>
              <tr>
                <th>パスフレーズ送信先<br/>(Eメールアドレス)</th>
                <td style="display:flex; align-items:center; gap:5px;">
                  <input v-model="userData.passPhraseMail" type="text" class="passPhrase" id="passphraseSendMail" name="パスフレーズ送信先(Eメールアドレス)" validate="mail" maxlength="256"/>
                  <b-button class="withButton" @click="sendTestMail()">テスト送信</b-button>
                </td>
              </tr>
              <tr></tr>
            </template>
            <template v-if="userRole == role.role_hospital">
              <tr>
                <th>CPAP患者レポート</th>
                  <td>
                  <b-checkbox class="cstmCheckBox" v-model="userData.cpapReport">CPAP患者レポートを利用する</b-checkbox>
                  </td>
              </tr>
              <template v-if="userData.cpapReport">
                <tr>
                  <th></th>
                  <td>
                    <b-checkbox class="columnCheckBox" style="width:100%!important" v-model="userData.pDashboardSignedFlag">医療機関へのCPAP患者レポート利用に関する同意確認が完了している</b-checkbox>
                  </td>
                </tr>
                <template v-if="userData.pDashboardSignedFlag">
                  <tr>
                    <th></th>
                    <td>
                      <b-button  v-if="userData.id" class="withButton" @click="goPDashboardMain()"
                        :disabled="!existsOrgList || !initialBelongOrgId || isChangedBelongOrg || userData.userStatus != extUserStatus.registed || userData.integratorUser != initialpDashboardInfo.integratorUser || userData.integratorKey != initialpDashboardInfo.integratorKey || userData.orgId != initialpDashboardInfo.orgId">
                          画面確認
                      </b-button>
                      <b-button  v-if="userData.id && !userData.lastConfirmationFlag" class="withButton" @click="doLastConfirm()"
                        :disabled="!userData.displayConfirmationFlag || isChangedBelongOrg || !existsOrgList || !initialBelongOrgId || userData.userStatus != extUserStatus.registed || userData.integratorUser != initialpDashboardInfo.integratorUser || userData.integratorKey != initialpDashboardInfo.integratorKey || userData.orgId != initialpDashboardInfo.orgId">
                          最終確認
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td style="display:flex; align-items:center; gap:5px;">
                      <span style="white-space: nowrap;">インテグレーターユーザー：</span>
                      <input type="text" style="width:285px;" v-model="userData.integratorUser" :disabled="userData.role == role.role_salesOffice" @input="inputIntegratorInfo()"/>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td style="display:flex; align-items:center; gap:5px;">
                      <span style="white-space: nowrap;">インテグレーターキー　　：</span>
                      <input :type="userData.role == role.role_salesOffice ? 'password' : 'text'" style="width: 285px;" v-model="userData.integratorKey" :disabled="userData.role == role.role_salesOffice" @input="inputIntegratorInfo()"/>
                      <b-button class="withButton" @click="doConnectConfirm()" :disabled="isNothingIntegratorInfo || userData.role == role.role_salesOffice">接続確認</b-button>
                    </td>
                  </tr>
                  <template v-if="userData.pDashboardOrgList && userData.pDashboardOrgList.length != 0">
                    <tr>
                      <th></th>
                      <td>ロケーション</td>
                    </tr>
                    <tr v-for="(org, index) in userData.pDashboardOrgList" :key="org.orgId">
                      <th></th>
                      <td>
                        <b-radio name="orgInfo" v-model="userData.orgId" :native-value="org.orgId" @input="selectBelongOrg()" style="padding-left:20px;" :disabled="userData.role == role.role_salesOffice">{{org.orgName}}</b-radio><br>
                        <span v-if="index==0" style="padding-left:80px;" :class="{ 'has-text-grey-light': userData.role == role.role_salesOffice }">住所：{{org.address}}</span>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </template>
            <tr><br></tr>
            </template>
            <tr v-if="!userData.portalFlag">
              <th style="font-size:13px;">【ポータル公開設定情報】</th>
            </tr>
            <tr>
              <th>
                情報ポータル公開範囲<span v-if="!userData.portalFlag" class="requireBrunch"/>
              </th>
              <td>
                <b-checkbox class="columnCheckBox"  disabled :value="true">お知らせ</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="userData.isEnabledGuidance" :disabled="userData.portalFlag">ご案内</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="userData.isEnabledEvent" :disabled="userData.portalFlag">学会・イベント情報</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="userData.isEnabledNews" :disabled="userData.portalFlag">ニュース</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="userData.isEnabledProduct" :disabled="userData.portalFlag">製品情報</b-checkbox>
              </td>
            </tr>
            <tr>
              <th style="width: 220px">定期メール送信設定<span v-if="!userData.portalFlag" class="requireBrunch"/></th>
              <td>
                <b-checkbox class="columnCheckBox" v-model="userData.isEnabledMail" :disabled="userData.portalFlag">定期メールを送信する</b-checkbox>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot" style="display: flex; justify-content: center;">
        <b-button v-if="!editFlag && !userData.portalFlag" class="is-primary withButton" @click="save()">追加</b-button>
        <b-button v-if="editFlag && !userData.portalFlag" class="is-primary withButton" @click="save()">更新</b-button>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  role,
  extUserStatus,
} from "@/components/mock/base/const.js";

export default {
  name: "UserAddModal",
  props: {
    userRole:{type:Number, default: null},
    userData:{type: Object, default: () => ({}) },
    initialpDashboardInfo:{type: Object, default: () => ({}) },
    editFlag:{type: Boolean, default: false },
  },
  methods: {
    // ユーザー追加処理
    save: function() {
      // バリデーションチェック
      var useInfoElements = document.getElementsByClassName("useInfo");
      var useInfoResults = this.selfMadeValidation(useInfoElements);
      var errorMsg = useInfoResults.msg;

      // メールアドレスと確認メールアドレスが一致しているかチェック
      if (this.userData.mail && this.userData.mailAddrcomfirm && this.userData.mail != this.userData.mailAddrcomfirm) {
        errorMsg = errorMsg + "メールアドレス(確認)が一致しません。\n";
        document.getElementById("mailAddrcomfirm").style["border-color"] = "red";
      }

      // パスフレーズ認証がオンの場合の送信先の入力チェック
      if (this.userData.passPhrase) {
        if (!this.userData.passPhrasePhoneNumber && !this.userData.passPhraseMail) {
          errorMsg = errorMsg + "パスフレーズ送信先はどちらか入力してください。\n";
          document.getElementById("passphraseSendNo").style["border-color"] = "red";
          document.getElementById("passphraseSendMail").style["border-color"] = "red";
        }

        // 携帯番号、メールアドレスの形式チェック
        var passPhraseElements = document.getElementsByClassName("passPhrase");
        var passPhraseResults = this.selfMadeValidation(passPhraseElements);
        errorMsg = errorMsg + passPhraseResults.msg;
      }

      // CPAP患者レポートチェック
      if (this.userRole == role.role_hospital && this.userData.cpapReport) {
        if (!this.userData.pDashboardSignedFlag) {
          errorMsg = errorMsg + "CPAP患者レポート利用契約が完了していることを確認してください。\n";
        }
        if (this.userData.integratorUser && this.userData.integratorKey && !this.userData.pDashboardOrgList) {
          errorMsg = errorMsg + "CPAP患者レポート設定の接続確認を行ってください。\n";
        }
      }

      if(errorMsg){
        this.showErrorMessage(errorMsg);
      } else {
        var dialogMsg = "";
        if (!this.editFlag) {
          dialogMsg = "ユーザー情報を追加しますか？";
        } else {
          dialogMsg = "ユーザー情報を更新しますか？";
        }

        const THIS = this;
        this.$dialog.confirm({
          title: "　",
          message: dialogMsg,
          cancelText: "キャンセル",
          confirmText: "OK",
          onConfirm: THIS.executeSaveUserInfo,
        });
      }
    },
    // 外部ユーザー登録画面への登録/更新パラメーター返却処理
    executeSaveUserInfo: function() {
      var userInfoObj = {};
      userInfoObj = {
        familyName: this.userData.familyName,
        firstName: this.userData.firstName,
        familyNameKana: this.userData.familyNameKana,
        firstNameKana: this.userData.firstNameKana,
        mail: this.userData.mail,
        passPhrase: this.userData.passPhrase,
        passPhrasePhoneNumber: this.userData.passPhrasePhoneNumber,
        passPhraseMail: this.userData.passPhraseMail,
        cpapReport: this.userData.cpapReport,
        pDashboardSignedFlag: this.userData.pDashboardSignedFlag,
        integratorUser: this.userData.integratorUser,
        integratorKey: this.userData.integratorKey,
        orgId: this.userData.orgId,
        pDashboardOrgList: this.userData.pDashboardOrgList,
        displayConfirmationFlag: this.userData.displayConfirmationFlag,
        isEnabledNotice: true,
        isEnabledGuidance: this.userData.isEnabledGuidance,
        isEnabledEvent: this.userData.isEnabledEvent,
        isEnabledNews: this.userData.isEnabledNews,
        isEnabledProduct: this.userData.isEnabledProduct,
        isEnabledMail: this.userData.isEnabledMail,
        index: this.userData.index,
        deleteFlag: false,
      };
      userInfoObj = JSON.parse(JSON.stringify(userInfoObj));
      this.$emit('select', userInfoObj);
      this.$parent.close();
    },
    // ユーザー削除処理
    deleteUser: function() {
      const THIS = this;
      this.$dialog.confirm({
        title: "　",
        message: "ユーザー情報を削除しますか？",
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: THIS.executeDeleteUserInfo,
      });
    },
    // 外部ユーザー登録画面への削除パラメーター返却処理
    executeDeleteUserInfo: function() {
      var userInfoObj = {};
      userInfoObj = {
        index: this.userData.index,
        deleteFlag: true,
      };
      userInfoObj = JSON.parse(JSON.stringify(userInfoObj));
      this.$emit('select', userInfoObj);
      this.$parent.close();
    },
    // パスフレーズ送信先（携帯番号）テスト送信処理
    sendTestSMS: function(){
      if(this.userData.passPhrasePhoneNumber != ""){
        var checkFields = [document.getElementById("passphraseSendNo")];
        var result = this.selfMadeValidation(checkFields);
        if(result.msg == ""){
          this.sendTest({
            passphraseSendMail:"",
            passphraseSendNo:this.userData.passPhrasePhoneNumber,
          });
        } else {
          this.showErrorMessage(result.msg);
        }
      } else {
        this.showErrorMessage("パスフレーズ送信先(携帯番号)を入力してください。");
      }
    },
    // パスフレーズ送信先（Eメールアドレス）テスト送信処理
    sendTestMail: function(){
      if(this.userData.passPhraseMail != ""){
        var checkFields = [document.getElementById("passphraseSendMail")];
        var result = this.selfMadeValidation(checkFields);
        if(result.msg == ""){
          this.sendTest({
            passphraseSendMail:this.userData.passPhraseMail,
            passphraseSendNo:"",
          });
        } else {
          this.showErrorMessage(result.msg);
        }
      } else {
        this.showErrorMessage("パスフレーズ送信先(Eメールアドレス)を入力してください。");
      }
    },
    // パスフレーズ送信先テスト送信処理
    sendTest: function(param){
      try {
        this.$store.dispatch("sendTest", {
          token: this.userData.token,
          contactAddress: param.passphraseSendMail,
          contactPhoneNumber: param.passphraseSendNo,
        }).then(result => {
          console.log(result);
          if(result != null && result.status === 200 ) {
            this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。");
          } else {
            this.showErrorMessage(result.message);
          }
          this.isActive = true;
        }).catch(error => {
          console.log(error);
          this.showErrorMessage("予期しないエラーが発生しました。");
        });
      } catch(err){
        console.log(err);
        this.showErrorMessage("予期しないエラーが発生しました。");
      }
    },
    // インテグレーターキー接続確認
    doConnectConfirm: function() {
      let _this = this;
      var userId = 0;
      if (_this.userData.id) {
        userId = _this.userData.id;
      }
      // インテグレーターキーに全角文字が含まれていなく、36文字の場合
      if (this.userData.integratorKey && !this.userData.integratorKey.match(/[^\x01-\x7E\uFF61-\uFF9F]/) && this.userData.integratorKey.length == 36) {
        // Web Api Call
        this.apiCall(
          function(client){
            return client.apis.internalMaintenance.getCOOrgListPOST({
              body:{
                integratorUser: _this.userData.integratorUser,
                integratorKey: _this.userData.integratorKey,
                userId: userId,
              }
            });
          },
          async function(result){
            // ケアオケの組織一覧取得が正常終了した場合のみ更新を行う
            if (result.obj.isSuccess) {
              _this.$set(_this.userData, 'pDashboardOrgList', result.obj.pDashboardOrgList);
              _this.userData.existsOrgList = true;
              _this.isDoneConnectConfirmation = true;
            }
            _this.showSuccess(result);
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      } else {
        this.showErrorMessage("インテグレーターキーは半角36文字で入力してください。");
      }
    },
    goPDashboardMain: function(){
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message:  "CPAP患者レポートに移動します。編集中のデータがある場合は先に「更新」を行ってください。<br>" + "CPAP患者レポートに移動しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setPDashboardUserMappingPOST({
                body:{
                  externalUserId: _this.userData.id,
                }
              });
            },
            async function(result){
              if(result && result.status == 200) {
                _this.userData.displayConfirmationFlag = true;
                await _this.$router.push({ name: "PDashboardMain" });
              } else {
                _this.showErrorMessage("予期しないエラーが発生しました。");
              }
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      })
    },
    doLastConfirm: function(){
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "この所属組織でCPAP患者レポートの利用を開始しますか？<br>開始すると本ユーザーに利用開始のお知らせメールを送信します。",
        cancelText: "キャンセル",
        onConfirm: async () => {
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.updateLastConfirmationPOST({
                body:{
                  userId: _this.userData.id,
                  mail: _this.userData.mail
                }
              });
            },
            async function(result){
              _this.userData.lastConfirmationFlag = true;
              //外部ユーザ追加・編集画面の患者ダッシュボード最終確認フラグを更新
              var userInfoObj = {
                lastConfirmationFlag: _this.userData.lastConfirmationFlag,
                index: _this.userData.index,
              };
              _this.$emit('pDushLastConfirm', userInfoObj);
              _this.showSuccess(result);
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    selectBelongOrg: function() {
      this.isSelectedBelongOrg = true;
      // 初期表示時に選択されていた組織と異なるものが選択された場合、画面確認・最終確認ボタンを押下不可にする
      if (this.userData.orgId != this.initialBelongOrgId) {
        this.isChangedBelongOrg = true;
      } else {
        this.isChangedBelongOrg = false;
      }
    },
    inputIntegratorInfo: function() {
      console.log("start inputIntegratorInfo")
      if (!this.userData.integratorUser || !this.userData.integratorKey) {
        this.isNothingIntegratorInfo = true;
      } else {
        this.isNothingIntegratorInfo = false;
      }
      // ロケーションリストリセット
      this.$set(this.userData, 'pDashboardOrgList', null);
      // ロケーション選択状態リセット
      this.userData.orgId = null;
      // ロケーション存在フラグをFalse
      this.existsOrgList = false;
      // 初期ロケーション存在フラグをFalse
      this.initialBelongOrgId = false;
      this.isDoneConnectConfirmation = false;
    },
  },
  data() {
    return {
      role: role,
      extUserStatus: extUserStatus,
      isNothingIntegratorInfo: false,
      existsOrgList:false,
      isDoneConnectConfirmation:false,
      isChangedBelongOrg: false,
    };
  },
  mounted: async function() {
    this.existsOrgList = this.userData.pDashboardOrgList && this.userData.pDashboardOrgList.length > 0 ? true : false;
    this.initialBelongOrgId = this.userData.orgId ? this.userData.orgId : false;
    this.isChangedBelongOrg = false;
    this.isNothingIntegratorInfo  = !this.userData.integratorUser || !this.userData.integratorKey ? true : false;
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
.condition-area th {
  vertical-align: middle;
}
.modal-card-head {
  position: relative;
}
.modal-card-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: whitesmoke;
}
.id-cell {
  display: flex;
  align-items: center;
}
.delete-button {
  margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/UserAddModal.vue